import { CampaignService } from '../../typings/campaignService';

export const SAVE_CAMPAIGN_SERVICE_EDITOR = 'SAVE_CAMPAIGN_SERVICE_EDITOR';
export type SAVE_CAMPAIGN_SERVICE_EDITOR = typeof SAVE_CAMPAIGN_SERVICE_EDITOR;

export interface SaveCampaignServiceEditor {
    type: SAVE_CAMPAIGN_SERVICE_EDITOR;
    campaignId: string;
    service: CampaignService;
}

export function saveCampaignServiceEditorAction(
    campaignId: string,
    service: CampaignService
): SaveCampaignServiceEditor {
    return {
        type: SAVE_CAMPAIGN_SERVICE_EDITOR,
        campaignId,
        service
    };
}
